/*
 * Copyright (c) 2022-2022. Revo Digital
 * ---
 * Author: gabrielecavallo
 * File: RevisionSelect.tsx
 * Project: mle-client-n
 * Committed last: 2022/11/3 @ 1753
 * ---
 * Description:
 */

import {MyLabelRevision} from "../../../../entities";
import {BaseSelectProps} from "../index";
import {ItemRenderer, Select} from "@blueprintjs/select";
import {useCallback} from "react";
import {Button, Intent, MenuItem, Tag} from "@blueprintjs/core";

const RSelect = Select.ofType<MyLabelRevision>();

/**
 * Componente per selezionare una revisione a partire da una lista
 * data
 * @param props
 * @constructor
 */
export const RevisionSelect = (props: BaseSelectProps<MyLabelRevision>) => {

    const itemRenderer: ItemRenderer<MyLabelRevision> = (item, {
        handleClick,
        index
    }) => {
        return (
            <MenuItem text={item.recipe_name}
                      labelElement={
                          <Tag intent={Intent.PRIMARY}>
                              {
                                  `${item.version_number.toString()}.${item.subversion_number.toString()}`
                              }
                          </Tag>
                      }
                      key={item.id}
                      onClick={handleClick}/>
        );
    };

    const handleSelectItem = useCallback((item: MyLabelRevision) => {
        props.onChange(item);
    }, []);

    return (
        <RSelect itemRenderer={itemRenderer} items={props.data}
                 onItemSelect={handleSelectItem} filterable={false}
                 disabled={props.disabled}>
            <Button rightIcon="caret-down" loading={props.isLoading}
                    disabled={props.disabled}>
                {
                    props.selectedValue && <div className="flex flex-row space-x-2">
                        <div>
                            {
                                props.selectedValue?.recipe_name
                            }
                        </div>
                        <div>
                            <Tag intent={Intent.PRIMARY}>
                                {
                                    `${props.selectedValue.version_number.toString()}.${props.selectedValue.subversion_number.toString()}`
                                }
                            </Tag>
                        </div>
                    </div>
                }
                {
                    !props.selectedValue && 'Seleziona una revisione'
                }
            </Button>
        </RSelect>
    );
}